/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 17V7M6 17L6 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.5 12H8.5M15.5 12L14 10.5M15.5 12L14 13.5M8.5 12L10 10.5M8.5 12L10 13.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M15.5 12H8.5M15.5 12L14 10.5M15.5 12L14 13.5M8.5 12L10 10.5M8.5 12L10 13.5M18 17V7M6 17V7M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM6.75 7C6.75 6.58579 6.41421 6.25 6 6.25C5.58579 6.25 5.25 6.58579 5.25 7V17C5.25 17.4142 5.58579 17.75 6 17.75C6.41421 17.75 6.75 17.4142 6.75 17V7ZM18.75 7C18.75 6.58579 18.4142 6.25 18 6.25C17.5858 6.25 17.25 6.58579 17.25 7V17C17.25 17.4142 17.5858 17.75 18 17.75C18.4142 17.75 18.75 17.4142 18.75 17V7ZM10.5303 11.0303C10.8232 10.7374 10.8232 10.2626 10.5303 9.96966C10.2374 9.67676 9.76257 9.67676 9.46968 9.96966L7.96967 11.4697C7.67677 11.7626 7.67677 12.2374 7.96967 12.5303L9.46968 14.0303C9.76257 14.3232 10.2374 14.3232 10.5303 14.0303C10.8232 13.7375 10.8232 13.2626 10.5303 12.9697L10.3107 12.75H13.6893L13.4697 12.9697C13.1768 13.2626 13.1768 13.7374 13.4697 14.0303C13.7626 14.3232 14.2374 14.3232 14.5303 14.0303L16.0303 12.5303C16.3232 12.2374 16.3232 11.7626 16.0303 11.4697L14.5303 9.96967C14.2374 9.67678 13.7626 9.67678 13.4697 9.96967C13.1768 10.2626 13.1768 10.7374 13.4697 11.0303L13.6893 11.25H10.3107L10.5303 11.0303Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M15.5 12H8.5M15.5 12L14 10.5M15.5 12L14 13.5M8.5 12L10 10.5M8.5 12L10 13.5M18 17V7M6 17V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15.5 12H8.5M15.5 12L14 10.5M15.5 12L14 13.5M8.5 12L10 10.5M8.5 12L10 13.5M18 17V7M6 17V7M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 6.25C6.41421 6.25 6.75 6.58579 6.75 7V17C6.75 17.4142 6.41421 17.75 6 17.75C5.58579 17.75 5.25 17.4142 5.25 17V7C5.25 6.58579 5.58579 6.25 6 6.25ZM18 6.25C18.4142 6.25 18.75 6.58579 18.75 7V17C18.75 17.4142 18.4142 17.75 18 17.75C17.5858 17.75 17.25 17.4142 17.25 17V7C17.25 6.58579 17.5858 6.25 18 6.25ZM10.5303 9.96966C10.8232 10.2626 10.8232 10.7374 10.5303 11.0303L10.3107 11.25L13.6893 11.25L13.4697 11.0303C13.1768 10.7374 13.1768 10.2626 13.4697 9.96967C13.7626 9.67678 14.2374 9.67678 14.5303 9.96967L16.0303 11.4697C16.3232 11.7626 16.3232 12.2374 16.0303 12.5303L14.5303 14.0303C14.2374 14.3232 13.7626 14.3232 13.4697 14.0303C13.1768 13.7374 13.1768 13.2626 13.4697 12.9697L13.6893 12.75L10.3107 12.75L10.5303 12.9697C10.8232 13.2626 10.8232 13.7375 10.5303 14.0303C10.2374 14.3232 9.76258 14.3232 9.46968 14.0303L7.96967 12.5303C7.67678 12.2374 7.67678 11.7626 7.96967 11.4697L9.46968 9.96966C9.76258 9.67676 10.2374 9.67676 10.5303 9.96966Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
